// extracted by mini-css-extract-plugin
export default {"closeBtn":"Header_closeBtn__UIcGS","linkcloseBtn":"Header_linkcloseBtn__Mb5uH","marginBtn":"Header_marginBtn__lhMDZ","title":"Header_title__l+wMf","head":"Header_head__8G-N7"};